import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { obtenerSolicitudesFC01SeguimientoNacionalAdmin, obtenerSolicitudesFC01SeguimientoNacionalAuxiliar } from '../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import BotonDescargarZipComponent from './BotonDescargarZipComponent'
import moment from 'moment'
import { ObtenerInformacionCliente, actualizarFC01_OCAccion } from '../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck'

function SeguimientoComponent(props) {
    const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.solicitudesSeguimientoOC)
    const dataUser = useSelector(store => store.Usuario.user)
    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')

    React.useEffect(async () => {
        if (dataUser[0]?.idrol == 1) await dispatch(obtenerSolicitudesFC01SeguimientoNacionalAdmin(2))
        if (dataUser[0]?.idrol == 7) await dispatch(obtenerSolicitudesFC01SeguimientoNacionalAuxiliar(dataUser?.[0].usuario))
    }, [])

    const columns = [

        { field: 'tipoSolicitud', headerAlign: 'center', headerName: 'Tipo de servicio', width: 300, },
        { field: 'folio', headerAlign: 'center', headerName: 'Folio', width: 130 },
        { field: 'numerosocio', headerAlign: 'center', headerName: 'No. de socio', width: 120 },
        { field: 'nombrerazonsocial', headerAlign: 'center', headerName: 'Razón social', width: 320 },
        { field: 'revisor', headerAlign: 'center', headerName: 'Revisor', width: 200 },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Seguimiento', width: 200,
            renderCell: (params) =>
                <div className='row'>
                    <ThemeProvider theme={theme}>
                        <div className={params?.row?.isVencida ? 'col-4' : "col-12"}>
                            <BotonDescargarZipComponent data={params?.row} />
                        </div>
                        {params?.row?.isVencida &&
                            <div className="col-8">
                                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => Revisar(params)}>Revisar</Button>
                            </div>
                        }
                    </ThemeProvider>
                </div>
        }
    ]
    
    let rows = []
    solicitudes?./*fc_01_solicitudderegistro.*/map(solicitud => {
        let isVencida = false
        let fechaVencimiento = solicitud?.solicitudesuifc01?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.fechavencimiento?.substring(0, 10)
        let fechaActual = moment().format('YYYY-MM-DD')
        let diasVencimiento = moment(fechaActual).diff(moment(fechaVencimiento), 'days')

        if(diasVencimiento >= 0) isVencida = true
        
        rows.push({
            id: uuidv4(), idfc01_solicitudregistro: solicitud?.idfc01_solicitudregistro,
            numerosocio: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.numerosocio,
            tipoSolicitud: 'Solicitud de inscripción',
            nombrerazonsocial: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.nombrerazonsocial,
            idlogin: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.idlogin, idsolicitudesuifc01: solicitud?.idsolicitudesuifc01,
            data: solicitud, folio: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.folio, revisor: solicitud?.revisor,
            idcliente: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.idcliente,
            idsolicitudesocfc01: solicitud?.idsolicitudesocfc01, tipo: 'Cliente', isVencida: isVencida
        })
    })

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>
            </Box>
        );
    }

    const Revisar = async (params) => {

        let fechaatendida = new Date(fechaHoy).toISOString()
        let data = {
            idestatusoc: 1, fechaatendida: fechaatendida, idcliente: params?.row?.idcliente,
            idsolicitudesocfc01: params?.row?.idsolicitudesocfc01
        }
        await dispatch(actualizarFC01_OCAccion(data))
        await dispatch(ObtenerInformacionCliente(params.row.idsolicitudesuifc01))
        props.history.push('/InformacionClienteComponent')
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 className='text-center mt-5 pt-3' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>SEGUIMIENTO</h3><br />
                <div style={{ height: 600, width: '100%', color: 'black', paddingTop: 0 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        components={{ Toolbar: QuickSearchToolbar }}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-cell': {
                                display: 'block',
                                position: 'relative',
                                textAlign: 'center',
                                paddingTop: '10px',
                                paddingBottom: '15px'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#0C365A',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(SeguimientoComponent)